<template>
  <Card :title="$t('global.performance-monitoring')">
    <LoadingState v-if="isLoading()" :size="50" />
    <ErrorState v-else-if="isErrored()" />
    <template v-else-if="site">
      <NewRelic :plan="plan" :site="site" />
    </template>
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import NewRelic from "@/components/smart/cards/NewRelic";

export default {
  name: "PerformanceMonitoring",
  components: {
    NewRelic,
    Card,
    ErrorState,
    LoadingState,
  },
  props: {
    plan: Object,
    planStatus: {
      type: Object,
      required: true,
    },
    site: Object,
    siteStatus: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const isErrored = () => props.planStatus.isErrored || props.siteStatus.isErrored;
    const isLoading = () => props.planStatus.isLoading || props.siteStatus.isLoading;

    return {
      isErrored,
      isLoading,
    };
  },
};
</script>
